import React from 'react';
import { typography, spacing, components } from '../utils/designTokens';

/**
 * PageHeader - Standard header for list pages
 * Displays title, optional display label (env + time range), optional view tabs, and optional breadcrumbs
 */
const PageHeader = ({ title, displayLabel, viewTabs, breadcrumbs, children }) => {
  if (!title) throw new Error('PageHeader requires title prop');

  return (
    <div className={`flex flex-col ${spacing.gap.md}`}>
      {breadcrumbs && (
        <div className="flex items-center">
          {breadcrumbs}
        </div>
      )}

      <div className="flex items-baseline justify-between">
        <div className={components.pageHeader.titleContainer}>
          <h1 className={`${typography.size.xl} ${typography.weight.bold} text-text-primary`}>
            {title}
          </h1>
          {displayLabel && (
            <span className={components.pageHeader.metadataClass} style={{ color: components.pageHeader.metadataColor }}>
              {displayLabel}
            </span>
          )}
          {viewTabs && viewTabs}
        </div>

        {children}
      </div>
    </div>
  );
};

export default PageHeader;
